<template>
    <div class="card shadow"
         :class="type === 'dark' ? 'bg-default': ''">
        <div class="card-header border-0"
             :class="type === 'dark' ? 'bg-transparent': ''">
            <div class="row d-flex align-items-center justify-content-between">
                <!-- the search box -->
                <el-input
                    type="search"
                    class="mr-3"
                    clearable
                    prefix-icon="el-icon-search"
                    style="width: 200px"
                    placeholder="Suche"
                    v-model="search"
                    aria-controls="datatables"
                >
                </el-input>
                <div>
                    <!--due today button-->
                    <base-button size="large" :type="(dueToday) ? 'danger': 'primary'" @click="activateDueToday">
                        Heute Fällig
                    </base-button>
                    <!-- Filter Tools Button-->
                    <base-button @click.prevent="showFilterTools " type="primary" class="match-height">
                        Filtern
                    </base-button>
                    <!-- Fall erstellen -->
                    <base-button class="newButton" title="Fall erstellen" @click.prevent="newIncident = true"
                                 type="success"><i
                        class="fad fa-plus-circle"></i>
                        Fall erstellen
                    </base-button>
                </div>
            </div>
        </div>
        <!-- collection of all modals and dialogs here -->
        <!-- Columns Filter Dialog -->
        <el-dialog v-model="modalDialogToggle" title="Spalten Ausblenden" width="500" draggable>
            <div v-for="(column, key) in table" class="ml-3">
                <el-checkbox v-model="table[key].visible" :label="column.header"></el-checkbox>
            </div>
            <template #footer>
                <div class="dialog-footer">
                    <base-button type="warning" @click="resetTableColumns()">Zurücksetzen</base-button>
                    <base-button type="primary" @click="modalDialogToggle = false">Annehmen</base-button>
                </div>
            </template>
        </el-dialog>

        <!--  Filtering (Tools) Dialog  -->
        <el-dialog v-model="toolsModal" title="Filtern" width="500" draggable>
            <div class="row modal-row">
                <div class="col m-1 my-auto">
                    <span>Jahr</span>
                </div>
                <!-- Select filters for year -->
                <div class="col m-1">
                    <el-select
                        class="select-primary pagination-select mr-3 mb-1 mySelect"
                        v-model="selectedYear"
                        default-first-option>
                        <el-option
                            label="Alle"
                            :value="0">
                        </el-option>
                        <el-option
                            v-for="item in targetDateYear"
                            :key="item"
                            :label="item"
                            :value="item">
                        </el-option>
                    </el-select>
                </div>
            </div>
            <div class="row modal-row">
                <div class="col m-1 my-auto">
                    <span>Monat</span>
                </div>
                <div class="col m-1">
                    <!-- Select filters for month -->
                    <el-select
                        class="select-primary pagination-select mr-3 mb-1 mySelect"
                        v-model="selectedMonth"
                        default-first-option
                        placeholder="Monat Auswählen">
                        <el-option
                            label="Alle"
                            :value="0">
                        </el-option>
                        <el-option
                            v-for="item in targetMonthList"
                            :key="item"
                            :label="item.name"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </div>
            </div>
            <div class="row modal-row">
                <div class="col m-1 my-auto">
                    <span>Status</span>
                </div>
                <div class="col m-1 d-flex justify-content-around align-items-center">
                    <base-button :type="(closed === 'false') ? 'primary': 'secondary'"
                                 size="sm"
                                 :class="{'active': closed === 'false'}" @click.prevent="setOpenIncidents"
                                 title="Offene anzeigen">
                        <i class="fad fa-lock-open"></i>
                    </base-button>
                    <base-button :type="(closed === 'true') ? 'default': 'secondary'" size="sm"
                                 :class="{'active': closed === 'true'}"
                                 @click.prevent="setClosedIncidents"
                                 title="Geschlossene anzeigen">
                        <i class="fad fa-lock"></i>
                    </base-button>
                </div>
            </div>
            <template #footer>
                <div class="dialog-footer">
                    <base-button type="warning" @click="resetToolsDialog" title="Alle Filter Zurücksetzen">
                        Zurücksetzen
                    </base-button>
                    <base-button type="primary" @click="toolsModal = false" title="Alle Filter Annehmen">Annehmen
                    </base-button>
                </div>
            </template>
        </el-dialog>

        <modal v-model:show="newIncident" modal-classes="modal-lg modal-dialog-centered">
            <template v-slot:header>
                <h4 class="modal-title" id="exampleModalLabel">Neuen Fall
                    erstellen</h4><br>
            </template>
            <div>
                <div class="row mb-3">
                    <div class="col ">
                        <el-input v-model="briefDescription"
                                  class="btn-block" placeholder="Kurzbeschreibung"
                                  required maxLength="80" minlength="10" input-style="description"/>
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col">
                        <el-select
                            id="category"
                            v-model="category"
                            class="btn-block"
                            @change="getSubCategories"
                            no-match-text="Kein Eintrag"
                            default-first-option
                            filterable
                            placeholder="Kategorie auswählen (optional)">
                            <el-option
                                v-for="(category, index) in categoryList"
                                :key="index"
                                :value="category.id"
                                :label="category.name">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col">
                        <el-select
                            id="subCategory"
                            v-if="category !== ''"
                            v-model="subCategory"
                            default-first-option
                            no-match-text="Kein Eintrag"
                            class="btn-block"
                            filterable
                            placeholder="Unterkategorie auswählen (optional)">
                            <el-option
                                v-for="(category, index) in subCategoryList"
                                :key="index"
                                :value="category.id"
                                :label="category.name">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <ckeditor class="form-control" v-model="newRequest" :editor="editor"
                          :config="editorConfig" :rows="4" required></ckeditor>
                <div><small class="font-italic">Bilder bis max 450px können in den Text eingefügt werden.
                    Grössere Bilder bitte als Anhang versenden</small></div>
                <small class="errorText" v-if="errorText.length > 0">
                    {{ errorText }}
                </small>
                <base-alert v-if="modalError.length > 0" type="danger" class="w-100">
                    <span class="alert-inner--text"><strong>Fehler!</strong>  {{ modalError }}</span>
                </base-alert>
                <dropzone-file-upload ref="dropzoneInstance" :options="dropzoneOptions"
                                      v-model="dropzoneFiles" class="mt-3"
                                      multiple></dropzone-file-upload>
            </div>
            <template v-slot:footer>
                <base-button :disabled="disabled" @click.prevent="clearForm" title="Eingaben löschen"
                             type="secondary">
                    Eingaben löschen
                </base-button>
                <base-button :disabled="disabled" title="Erstellen" @click.prevent="createIncident"
                             type="success">
                    Erstellen
                </base-button>
            </template>
        </modal>

        <!--    The Incidents Table -->
        <div class="table-responsive">
            <el-table class="table-responsive clickableRow"
                      :class="type === 'dark' ? 'table-dark': ''"
                      :thead-classes="type === 'dark' ? 'thead-dark': 'thead-light'"
                      tbody-classes="list"
                      :data="incidents"
                      ref="tableData"
                      @filter-change="filterIncidents"
                      :row-class-name="tableRowClassName"
                      :default-sort="{ prop: 'creationDate', order: 'descending' }"
                      empty-text="Keine Einträge vorhanden"
                      @sort-change="changeSort"
                      @row-click="getIncident($event.id)"
                      @header-click="headerClick">
                <el-table-column prop="caller.Id" sortable="custom" :sort-orders="['ascending', 'descending']"
                                 label="Fallnummer" min-width="130px" v-if="table.number.visible">
                    <template v-slot="{ row }">

                        <div class="media align-items-center">
                            <el-tooltip
                                :content="(row.priority ) ? 'Priorität: ' + row.priority.name : 'Priorität: nicht definiert'"
                                placement="top">
                                <badge class="mr-3" type="warning"
                                       v-if="row.priority && row.priority.name == 'sehr hoch'">
                                    <i class="fa-sharp fa-solid fa-triangle-exclamation"></i>
                                </badge>
                                <badge class="mr-3"
                                       :type="(row.priority ) ? getPriorityType(row.priority.name) : 'primary'" v-else>
                                    <i class="fad fa-ticket"></i>
                                </badge>
                            </el-tooltip>
                            {{ (row.number) ? row.number : '' }}
                        </div>
                    </template>
                </el-table-column>

                <el-table-column prop="briefDescription" sortable="custom" :sort-orders="['ascending', 'descending']"
                                 label="Kurzbeschreibung" min-width="170px" v-if="table.briefDescription.visible">
                    <template v-slot="{ row }">
                        {{ (row.briefDescription) ? row.briefDescription : '' }}
                    </template>
                </el-table-column>

                <el-table-column prop="caller.dynamicName" sortable="custom" :sort-orders="['ascending', 'descending']"
                                 :filters="callerList" column-key="callers" confirmButtonText="go"
                                 label="Name Anmelder" min-width="170px" v-if="table.dynamicName.visible">
                    <template #el-table-filter="{ column, $index }">
                        <el-input
                            v-model="filterValue"
                            placeholder="Type to filter"
                            class="filter-input"
                        />
                        <el-button @click="handleConfirm(column)">go</el-button>
                        <el-button @click="handleReset(column)">Reset</el-button>
                    </template>
                    <template v-slot="{ row }">
                        {{ (row.caller) ? row.caller.dynamicName : '' }}
                    </template>
                </el-table-column>

                <el-table-column prop="operator.name" sortable="custom" :sort-orders="['ascending', 'descending']"
                                 :filters="operatorList" column-key="operators" confirmButtonText="blub"
                                 label="Bearbeiter" min-width="170px" v-if="table.operator.visible">
                    <template v-slot="{ row }">
                        {{ (row.operator) ? row.operator.name : '' }}
                    </template>
                </el-table-column>

                <el-table-column prop="completed" sortable="custom" :sort-orders="['ascending', 'descending']"
                                 label="Status" min-width="100px" v-if="table.completed.visible">
                    <template v-slot="{ row }">
                        <i :class="{'fad fa-lock': row.completed, 'fad fa-lock-open text-primary': !row.completed}"></i>
                    </template>
                </el-table-column>

                <el-table-column prop="targetDate" sortable="custom" :sort-orders="['ascending', 'descending']"
                                 label="Fällig" min-width="170px" v-if="table.targetDate.visible">
                    <template v-slot="{ row }">
                        {{ convertDate(row.targetDate) }}
                        <el-tag v-if="isInDue(row)"
                                class="ml-1 middleTag" :type="getDueType(row.targetDate)">
                            <i class="fad fa-hourglass-end"></i>
                        </el-tag>
                    </template>
                </el-table-column>

                <el-table-column prop="creationDate" sortable="custom" :sort-orders="['ascending', 'descending']"
                                 label="Erstellt am" min-width="170px" v-if="table.creationDate.visible">
                    <template v-slot="{ row }">
                        {{ convertDate(row.creationDate) }}
                    </template>
                </el-table-column>

                <el-table-column prop="category.name" sortable="custom" :sort-orders="['ascending', 'descending']"
                                 label="Kategorie" min-width="170px" v-if="table.category.visible"
                                 :filters="categoryListFilter" column-key="categories">
                    <template v-slot="{ row }">
                        {{ (row.category) ? row.category.name : '' }}
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="card-footer d-flex justify-content-between" :class="type === 'dark' ? 'bg-transparent': ''">
            <!-- Incidents Per Page -->
            <el-select
                class="select-primary pagination-select mr-3 mb-1 perPageSelect"
                v-model="perPage"
                default-first-option
                placeholder="Einträge pro Seite"
            >
                <el-option
                    class="select-primary"
                    v-for="item in perPageOptions"
                    :key="item"
                    :label="item"
                    :value="item"
                >
                </el-option>
            </el-select>
            <!-- The Paginator -->
            <base-pagination v-model="pagination" :total="total" :perPage="pageSize"></base-pagination>
        </div>
        <base-alert v-if="error.length > 0" type="danger">
            <span class="alert-inner--text"><strong>Fehler!</strong>  {{ error }}</span>
        </base-alert>
    </div>
</template>
<script>
import {ref, watch, computed, onMounted, reactive} from 'vue';
import {useStore} from 'vuex';
import {useRouter} from 'vue-router'
import {
    ElTable,
    ElTableColumn,
    TableColumnCtx,
    ElDropdownMenu,
    ElDropdownItem,
    ElDropdown,
    ElInput,
    ElButton,
    ElTag,
    ElSelect,
    ElOption,
    ElCard,
    ElCheckbox,
    ElDialog,
    ElSwitch
} from "element-plus";
import moment from 'moment';
import swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.css";
import Modal from "@/components/Modal";
import BaseAlert from "@/components/BaseAlert";
import RouteBreadcrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import BaseHeader from "@/components/BaseHeader";
import BaseDropdown from "@/components/BaseDropdown";
import UserService from '@/services/user.service';
import ClassicEditor from "@ckeditor/ckeditor5-editor-classic/src/classiceditor";
import EssentialsPlugin from "@ckeditor/ckeditor5-essentials/src/essentials";
import BoldPlugin from "@ckeditor/ckeditor5-basic-styles/src/bold";
import ItalicPlugin from "@ckeditor/ckeditor5-basic-styles/src/italic";
import LinkPlugin from "@ckeditor/ckeditor5-link/src/link";
import ParagraphPlugin from "@ckeditor/ckeditor5-paragraph/src/paragraph";
import Image from "@ckeditor/ckeditor5-image/src/image";
import ImageUpload from "@ckeditor/ckeditor5-image/src/imageupload";
import Base64UploadAdapter from "@ckeditor/ckeditor5-upload/src/adapters/base64uploadadapter";
import BaseInput from "../../components/Inputs/BaseInput";
import DropzoneFileUpload from "@/components/Inputs/DropzoneFileUpload";
import User from "../../models/user";
import tab from "../../components/Tabs/Tab";
import BaseButton from "../../components/BaseButton.vue";
import {ArrowDown} from '@element-plus/icons-vue'
import BaseSwitch from "@/components/BaseSwitch";


export default {
    name: 'IncidentsTable',
    components: {
        BaseButton,
        BaseInput,
        [ElTable.name]: ElTable,
        [ElTableColumn.name]: ElTableColumn,
        [ElDropdown.name]: ElDropdown,
        [ElDropdownItem.name]: ElDropdownItem,
        [ElDropdownMenu.name]: ElDropdownMenu,
        [ElButton.name]: ElButton,
        [ElInput.name]: ElInput,
        [ElTag.name]: ElTag,
        [ElSelect.name]: ElSelect,
        [ElOption.name]: ElOption,
        [ElCard.name]: ElCard,
        [ElCheckbox.name]: ElCheckbox,
        [ElDialog.name]: ElDialog,
        [ElSwitch.name]: ElSwitch,
        Modal,
        BaseAlert,
        RouteBreadcrumb,
        BaseHeader,
        BaseDropdown,
        DropzoneFileUpload,
        BaseSwitch
    },
    props: {
        type: {
            type: String
        },
        title: String,
        showOpenIncidents: {
            type: Boolean,
            required: false
        }
    },
    setup(props, {emit}) {
        const store = useStore();
        const tableData = ref(null);

        function formatIncidentText(value) {
            return value.replace(/<p>/gm, '').replace(/<\/p>/gm, '<br>').replace(/<\/figure>/gm, '').replace(/<figure.+?>/gm, '');
        }

        function setStatus(value) {
            store.commit('incidents/setStatus', value);
        }

        function setClosed(value) {
            store.commit('incidents/setClosing', value);
        }

        function setPageSize(value) {
            store.commit('incidents/setPageSize', value);
        }

        function convertDate(date) {
            return moment(date).format('DD.MM.YYYY HH:mm');
        }

        const error = ref('');

        function getError(request) {
            if (request.response && request.response.status == '401') {
                error.value = 'you are not logged in!';
            } else if (request.response && request.response.status == '403') {
                error.value = 'you are not permitted!';
            } else {
                error.value =
                    (request.response && request.response.data) ||
                    request.message ||
                    request.toString();
            }
        }

        // get the filters pertaining to records
        function getFilters() {
            UserService.getFilters().then(
                response => {
                    callerList.value = response.data.callers.map(entry => {
                        let caller = {};
                        caller.value = entry.id;
                        caller.text = entry.name;
                        return caller;
                    }).filter(caller => caller.value !== null);

                    operatorList.value = response.data.operators.map(entry => {
                        let operator = {};
                        operator.value = entry.id;
                        operator.text = entry.name;
                        return operator;
                    });
                    targetDateYear.value = response.data.targetDates;

                    const filterButtons = document.querySelectorAll('.el-table-filter__bottom button:first-child');
                    filterButtons.forEach((element, index) => {
                        element.innerHTML = "Filtern";
                    });

                    const resetButtons = document.querySelectorAll('.el-table-filter__bottom button:last-child');
                    resetButtons.forEach((element, index) => {
                        element.innerHTML = "Zurücksetzen";
                    });
                },
                error => {
                    getError(error);
                }
            );
        }

        // Filters the incidents by the column that was selected from the table;
        // ie: when filtering in the operator col, then filterColumn will contain an Object of operator ids
        const filterIncidents = (filterColumn) => {
            for (let prop in filterColumn) {
                filters[prop] = filterColumn[prop]; // assign the entire array
            }
        }
        const category = ref('');
        const subCategories = ref([]);
        const categoryList = ref([]);
        const categoryListFilter = ref([]);

        function getCategories() {
            UserService.getCategories().then(
                response => {
                    subCategories.value = response.data.data.map(entry => {
                        let category = {};
                        category.id = entry.id;
                        category.name = entry.name;
                        category.idMain = entry.category.id;
                        return category;
                    });
                    categoryList.value = response.data.data.map(entry => {
                        let category = {};
                        category.id = entry.category.id;
                        category.name = entry.category.name;
                        return category;
                    }).reduce((c, e) => {
                        if (!c[e.id]) c[e.id] = e;
                        return c;
                    }, {})
                    let catListFilter = []
                    for (let key in categoryList.value) {
                        catListFilter = [...catListFilter, {
                            text: categoryList.value[key].name,
                            value: categoryList.value[key].id
                        }]
                    }
                    categoryListFilter.value = catListFilter
                },
                error => {
                    getError(error);
                }
            );
        }

        function getPriorityType(priority) {
            if (priority === 'niedrig')
                return 'success'
            else if (priority === 'hoch')
                return 'warning'
            else
                return 'primary'
        }

        const subCategory = ref('');
        const subCategoryList = ref([]);

        function getSubCategories() {
            subCategory.value = '';
            subCategoryList.value = subCategories.value.filter(entry => (entry.idMain === category.value));
        }

        const briefDescription = ref('');
        const newRequest = ref('');
        const newIncident = ref(false);
        const errorText = ref('');
        const modalError = ref('');
        const toolsModal = ref(false);
        const resetToolsDialog = () => {
            // reset all filters in tools modal to default
            setStatus(null);
            setClosed(null); // show open and closed
            resetSelectedYear();
            changeSort({prop: 'creationDate', order: 'desc'});
        }

        const showFilterTools = () => {
            toolsModal.value = true;
            dueToday.value = false // turn this button off
        };

        // Operator / Bearbeiter Filter related setup; reactive does not require '.value'
        const filters = reactive({
            operators: [],
            callers: [],
            categories: [],
            targetYear: null,
            targetMonth: null
        });
        const selectedYear = ref(0); // for template select input
        const resetSelectedYear = () => {
            selectedYear.value = 0
        };
        watch(selectedYear, () => {
            // using 0 is a crutch in order to retire a vue warning that the return type null is not allowed
            selectedYear.value !== 0 ? filters.targetYear = selectedYear.value : filters.targetYear = null
            setStatus(null); // return status button to neutral
            if (!filters.targetYear) selectedMonth.value = null // reset months if no year selected

        });
        const selectedMonth = ref(0); // for template select input
        // reset month filter when year filter is reset
        watch(selectedMonth, () => {
            selectedMonth.value !== 0 ? filters.targetMonth = selectedMonth.value : filters.targetMonth = null
        })

        const setClosedIncidents = () => {
            if (store.state.incidents.closed === 'true') {
                start.value = 0
                setClosed(null) // allow closed and open incidents (neutralize)
                return
            }
            setClosed('true')
        }

        const setOpenIncidents = () => {
            if (store.state.incidents.closed === 'false') {
                start.value = 0
                setClosed(null) // allow closed and open incidents (neutralize)
                return
            }
            setClosed('false')
        }
        watch(filters, () => {
            dueToday.value = false // turn switch off
            getIncidents();
        });
        // these refs are for filtering purposes
        const operatorList = ref([]); // stores list for showing in each column filter
        const callerList = ref([]);
        const targetDateYear = ref([]); // list of all years returned from getFilters
        const targetMonthList = ref([
            {name: 'Januar', value: 1},
            {name: 'Februar', value: 2},
            {name: 'März', value: 3},
            {name: 'April', value: 4},
            {name: 'Mai', value: 5},
            {name: 'Juni', value: 6},
            {name: 'Juli', value: 7},
            {name: 'August', value: 8},
            {name: 'September', value: 9},
            {name: 'Oktober', value: 10},
            {name: 'November', value: 11},
            {name: 'Dezember', value: 12},
        ]);

        const statusFilter = ref('');
        watch(statusFilter, () => {
            store.commit('incidents/setStatus', statusFilter.value)
        });

        const dueToday = ref(false)
        const activateDueToday = () => {
            if (!dueToday.value) {
                setStatus('today');
                setClosed('false');
                tableData.value.sort('targetDate', 'ascending');
                dueToday.value = !dueToday.value;  // toggle activator
                return
            }
            // 'deactivate' and reset display status to default
            resetToolsDialog();
            dueToday.value = !dueToday.value // flip the toggle back
        }

        const disabled = ref(false);
        const table = getTableColumns();

        function getTableColumns() {
            if (sessionStorage.getItem('incidentsTable') !== null) {
                return ref(JSON.parse(sessionStorage.getItem('incidentsTable')));
            } else {
                return ref({
                    number: {visible: true, header: "Fallnummer", key: "number"},
                    briefDescription: {visible: true, header: "Kurzbeschreibung", key: "briefDescription"},
                    dynamicName: {visible: true, header: "Name Anwender", key: "dynamicName"},
                    operator: {visible: true, header: "Bearbeiter", key: "operator"},
                    completed: {visible: true, header: "Status", key: "completed"},
                    targetDate: {visible: true, header: "Fällig", key: "targetDate"},
                    creationDate: {visible: true, header: "Erstellt am", key: "creationDate"},
                    category: {visible: true, header: "Kategorie", key: "category"}
                });
            }
        }

        watch(table, (value) => {
            sessionStorage.setItem('incidentsTable', JSON.stringify(value));
        }, {deep: true});

        function resetTableColumns() {
            this.table = {
                number: {visible: true, header: "Fallnummer", key: "number"},
                briefDescription: {visible: true, header: "Kurzbeschreibung", key: "briefDescription"},
                dynamicName: {visible: true, header: "Name Anwender", key: "dynamicName"},
                operator: {visible: true, header: "Bearbeiter", key: "operator"},
                completed: {visible: true, header: "Status", key: "completed"},
                targetDate: {visible: true, header: "Fällig", key: "targetDate"},
                creationDate: {visible: true, header: "Erstellt am", key: "creationDate"},
                category: {visible: true, header: "Kategorie", key: "category"}
            };
            sessionStorage.clear();
        }

        function clearForm() {
            newRequest.value = '';
            subCategory.value = '';
            category.value = '';
            dropzoneFiles.value = [];
            dropzoneInstance.value['dropzone'].removeAllFiles();
            disabled.value = false;
        }

        function createIncident() {
            if (newRequest.value.length <= 16) {
                errorText.value = "Bitte geben Sie einen Text mit mindestens 10 Zeichen ein!";
                return false;
            }
            if (briefDescription.value.length < 10 || briefDescription.value.length > 80) {
                errorText.value = "Bitte geben Sie einen Kurzbeschreibung mit mindestens 10 und maxmimal 80 Zeichen ein!";
                return false;
            }
            let id
            disabled.value = false;
            newRequest.value = formatIncidentText(newRequest.value);
            if (dropzoneFiles.value.length > 0) {
                for (const file of dropzoneFiles.value) {
                    if (file.size >= 2097152) {
                        modalError.value = 'Die Datei ist zu groß. Die maximale Dateigrösse beträgt 2MB';
                        return false;
                    }
                }
            }
            UserService.createIncident(briefDescription.value, newRequest.value, category.value, subCategory.value, dropzoneFiles.value).then(
                response => {
                    id = response.data.incidentId;
                    swal.fire({
                        icon: 'success',
                        title: 'Fall erfolgreich erstellt',
                        showConfirmButton: false,
                        timer: 2000
                    });
                    if (id && dropzoneFiles.value.length > 0) {
                        UserService.createAttachment(id, dropzoneFiles.value);
                    }
                    getIncidents();
                    clearForm();
                    errorText.value = '';
                    newIncident.value = false;
                },
                error => {
                    getError(error);
                }
            );
        }

        const router = useRouter();

        function getIncident(id) {
            router.push('/incidents/' + id);
        }

        const incidents = ref([]);
        const total = computed({
            get() {
                return store.state.incidents.total;
            },
            set(value) {
                store.commit('incidents/setTotal', value);
            }
        });
        const start = computed({
            get() {
                return store.state.incidents.start;
            },
            set(value) {
                store.commit('incidents/setStart', value);
            }
        });

        function getIncidents() {
            UserService.getIncidents(start.value, pageSize.value, status.value, closed.value, search.value, sort.value, filters.callers, filters.operators, filters.targetYear, filters.targetMonth, filters.categories).then(
                response => {
                    incidents.value = response.data.data;
                    total.value = response.data.recordsTotal; // STORM warning, but works
                    error.value = '';
                    disabled.value = false;
                },
                error => {
                    getError(error);
                }
            );
        }

        const perPage = ref(10);
        watch(perPage, (value) => {
            setPageSize(value);
        });

        const search = computed({
            get() {
                return store.state.incidents.searchString;
            },
            set(value) {
                store.commit('incidents/setSearch', value);
            }
        });
        watch(search, () => {
            getIncidents();
        });
        const sort = computed({
            get() {
                return store.state.incidents.sort;
            },
            set(value) {
                store.commit('incidents/setSort', value);
            }
        });
        watch(sort, () => {
            getIncidents();
        });
        const changeSort = (value) => {
            sort.value = {
                prop: value.prop,
                order: (value.order === 'ascending') ? 'asc' : 'desc'
            }
        };

        const pagination = computed({
            get() {
                return store.state.incidents.pagination;
            },
            set(value) {
                store.commit('incidents/setPagination', value);
            }
        });
        watch(pagination, () => {
            start.value = (pagination.value - 1) * pageSize.value;
        });

        watch(start, () => {
            getIncidents();
        });

        const status = computed(() => store.state.incidents.status);
        watch(status, () => {
            getIncidents();
        });

        const closed = computed(() => store.state.incidents.closed);
        watch(closed, () => {
            // if (closed === null) dueToday.value = false // turn switch off
            getIncidents();
        });

        const pageSize = computed(() => store.state.incidents.pageSize);
        watch(pageSize, () => {
            getIncidents();
        });
        const dropzoneInstance = ref(null);
        const dropzoneFiles = ref([]);
        const dropzoneOptions = ref({
            dictDefaultMessage: "Klicken Sie hier, oder legen Sie Dateien hier ab um sie hochzuladen",
            dictFallbackMessage: "Ihr Browser unterstützt Drag&Drop Dateiuploads nicht",
            dictFallbackText: "Benutzen Sie das Formular um Ihre Dateien hochzuladen",
            dictFileTooBig: "Die Datei ist zu groß. Die maximale Dateigrösse beträgt {{maxFileSize}}MB",
            dictInvalidFileType: "Eine Datei dieses Typs kann nicht hochgeladen werden",
            dictResponseError: "Der Server hat ihre Anfrage mit Status {{statusCode}} abgelehnt",
            dictCancelUpload: "Hochladen abbrechen",
            dictCancelUploadConfirmation: "Möchten Sie diesen Upload wirklich abbrechen?",
            dictRemoveFile: "Datei entfernen",
            dictMaxFilesExceeded: "Sie können keine weiteren Dateien mehr hochladen",
            paramName: "file",
            autoProcessQueue: false,
            maxFilesize: 2097152, //2mb in bytes

        });


        onMounted(() => {
            if (props.showOpenIncidents) setClosed(!props.showOpenIncidents) // show opposite
            getIncidents();
            getCategories();
            // getFilters must come after getCategories, since category filters are built from its call
            getFilters();
            perPage.value = pageSize.value;
        });

        const isInDue = (row) => {
            if (!row.closed) {
                if (moment(row.targetDate) < moment()) {
                    return true;
                } else if (moment(row.targetDate).format('DDMMYY') === moment().format('DDMMYY')) {
                    return true
                }
            }
            return false;
        };

        const getDueType = (date) => {
            if (moment(date) < moment()) {
                return 'danger';
            } else if (moment(date).format('DDMMYY') === moment().format('DDMMYY')) {
                return 'warning';
            } else {
                return '';
            }
        };

        const tableRowClassName = ({row, rowIndex}) => {
            if (!row.closed) {
                if (moment(row.targetDate) < moment()) {
                    return 'hover incident-danger'
                } else if (moment(row.targetDate).format('DDMMYY') === moment().format('DDMMYY')) {
                    return 'hover incident-warning'
                }
            }
            return 'hover'
        };
        const modalDialogToggle = ref(false)
        const headerClick = () => {
            modalDialogToggle.value = true // open El-Dialog
        }

        return {
            headerClick,
            modalDialogToggle,
            activateDueToday,
            setClosedIncidents,
            setOpenIncidents,
            resetToolsDialog,
            showFilterTools,
            currentUser: computed(() => store.state.auth.user),
            perPageOptions: ref([10, 20, 50, 100]),
            perPage,
            filterIncidents,
            changeSort,
            clearForm,
            pagination,
            pageSize,
            total,
            briefDescription,
            newRequest,
            newIncident,
            status,
            closed,
            incidents,
            getIncident,
            createIncident,
            category,
            subCategory,
            categoryList,
            subCategoryList,
            categoryListFilter,
            getSubCategories,
            selectedYear,
            resetSelectedYear,
            selectedMonth,
            targetMonthList,
            getPriorityType,
            error,
            errorText,
            modalError,
            toolsModal,
            operatorList,
            targetDateYear,
            filters,
            dueToday,
            callerList,
            statusFilter,
            convertDate,
            setStatus,
            tableData,
            setClosed,
            disabled,
            isInDue,
            getDueType,
            table,
            resetTableColumns,
            getTableColumns,
            tableRowClassName,
            dropzoneInstance,
            dropzoneOptions,
            dropzoneFiles,
            search,
            editor: ClassicEditor,
            editorConfig: {
                language: 'de',
                plugins: [
                    EssentialsPlugin,
                    BoldPlugin,
                    ItalicPlugin,
                    LinkPlugin,
                    ParagraphPlugin,
                    Image,
                    ImageUpload,
                ],
                image: {
                    upload: {
                        types: ['png', 'jpeg', 'bmp', 'gif']
                    }
                },
                extraPlugins: [Base64UploadAdapter],
                toolbar: {
                    items: [
                        'bold',
                        'italic',
                        '|',
                        'link',
                        'imageUpload',
                        '|',
                        'undo',
                        'redo',
                    ]
                }
            },

        };
    },
}
</script>
<style lang="scss">

:root {
    --ck-border-radius: 0.375rem;
}

.tableCard {
    max-width: 300px;
}

.perPage {
    width: 70px;
    float: left;
    margin-right: 1rem;
}

.newButton {
    padding: 0.76rem 1.25rem !important;

}

.match-height {
    height: 44px;
}

.clickableRow {
    tbody tr td {
        cursor: pointer;
    }

    .el-table__expanded-cell {
        cursor: default;
    }
}

.ck-editor__editable {
    min-height: 150px;
}

.errorText {
    color: #f5365c;
}

.el-input__inner {
    font-size: 0.875rem;
    width: 100%;
    height: calc(1.5em + 1.25rem + 2px) !important;
}

span.middleTag {
    vertical-align: inherit;
    text-align: center;
    border-radius: 50%;
    padding: 8px;
}

/* this does not get rid of the input focus :-( */
.el-select .el-input .el-input__inner:focus {
    outline: none !important;
}

.perPageSelect {
    width: 7%;
}


/*tr.incident-danger {
    background-color: rgba(236, 12, 56, 0.7) !important;
}

tr.incident-warning {
    background-color: rgba(251, 99, 64, 0.7) !important;
}

tr.incident-danger td, tr.incident-warning td {
    color: white;
}*/

</style>

<style scoped>
.modal-row {
    height: 60px;
}
</style>
